import { render, staticRenderFns } from "./ParticipantsDetail.vue?vue&type=template&id=a15a42b2&"
import script from "./ParticipantsDetail.vue?vue&type=script&lang=js&"
export * from "./ParticipantsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports